import { isSameDay } from 'date-fns'

import { Role } from '@/types/auth'
import { Log, MileageLossCode } from '@/types/logs'
import { IUserInfoResponse } from '@/types/user'

export const checkIsCreateMileageLossAvailable = (
    log: Log,
    role: Role | null,
    userInfo?: IUserInfoResponse
): boolean => {
    const canLogBeUpdated = log.codingPeriodInfo.permissions.includes('Update')
    const isDailyLogCode = !(log.code in MileageLossCode) && !log.eventLog

    if (role === Role.Reader) {
        return false
    }

    const canCreate = isDailyLogCode && canLogBeUpdated

    if (role && [Role.MileageClerk, Role.PerformanceManager].includes(role)) {
        return canCreate
    }

    return (
        canCreate && !!userInfo && isSameDay(new Date(userInfo.lastSessionDetails.startedAt), new Date(log.timestamp))
    )
}
